import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store/store';

const AffirmBnplButtonIcon = () => {
  const cdn = useSelector((state: RootState) => state.config.endpoints.cdn);

  return (
    <span className="affirm-content">
      <span className="affirm-text">Pay over time with&nbsp;</span>
      <img
        src={`${cdn}/affirm_white_logo_solid_bg.svg`}
        alt="Affirm"
        style={{ height: '23px', width: '47px' }}
      />
      <style jsx>{`
        .affirm-content {
          display: inline-flex;
          align-items: center;
          color: white;
          font-weight: bold;
          font-size: 16px;
          position: relative;
          top: -3px;
        }
        .affirm-text {
          position: relative;
          top: 4px;
        }
      `}</style>
    </span>
  );
};

export default AffirmBnplButtonIcon;
